import React from 'react';
import { SecuritySettings } from 'components/Settings/Sections/SecuritySettings/SecuritySettings';
import { SupportAndFeedback } from 'components/Settings/Sections/SupportAndFeedback/SupportAndFeedback';
import { useNotificationSettings } from 'features/settings/hooks/useNotificationSettings';
import {
  isAccountSettings,
  isNotificationSettings,
  isSecuritySettings,
  isSupportSettings,
} from 'features/settings/types/typeGuards';
import { SettingsSectionId } from 'features/settings/types/types';
import { List } from '@mui/material';
import { useDeviceType } from 'contexts/ThemeContext/hooks/useDeviceType';
import { MobileManageAccountContent } from '../Sections/ManageAccount/MobileManageAccountContent';
import { NotificationPreferencesContent } from '../Sections/NotificationSettings/NotificationPreferencesContent';
import DataPreferences from '../Sections/SecuritySettings/DataPreferences';

interface SettingsModalContentProps {
  sectionId: SettingsSectionId;
}

export const SettingsModalContent = ({ sectionId }: SettingsModalContentProps) => {
  const {
    enabled,
    chatNotificationEnabled,
    memberNotificationEnabled,
    memberSmsEnabled,
    memberLoaded,
    userPhoneNumber,
    enabledInExternalSystem,
    hospitalTwilioSmsNumber,
    onChangeNotificationPreferences,
  } = useNotificationSettings();
  const { isDesktop } = useDeviceType();

  return (
    <>
      {isAccountSettings(sectionId) && <MobileManageAccountContent />}
      {isNotificationSettings(sectionId) && (
        <NotificationPreferencesContent
          enabledInExternalSystem={enabledInExternalSystem}
          enabled={enabled}
          chatNotificationsEnabled={chatNotificationEnabled}
          memberNotificationEnabled={memberNotificationEnabled}
          memberSmsEnabled={memberSmsEnabled}
          memberLoaded={memberLoaded}
          userPhoneNumber={userPhoneNumber}
          hospitalTwilioSmsNumber={hospitalTwilioSmsNumber}
          onChangeNotificationPreferences={onChangeNotificationPreferences}
        />
      )}
      {/* Wrapped DataPreferences in List component to maintain proper HTML structure
        and ensure consistent spacing. This prevents nested list elements when
        rendered on desktop where DataPreferences is already wrapped in a List. : WFMOB-15242 */}
      {isSecuritySettings(sectionId) && (
        <List aria-labelledby="security__settings-header" sx={!isDesktop ? { padding: 3 } : {}}>
          <DataPreferences />
        </List>
      )}
      {isSupportSettings(sectionId) && <SupportAndFeedback />}
    </>
  );
};
